// @dynamic
export class NotificationRelativePath {
  static get AddNotificationUrl() {
    return ['notifications/edit'];
  }
  static getEditNotificationByAlertIdUrl(alertId: string) {
    return [`notifications/edit/${alertId}`];
  }
}
